export const getDiamondStandingsChannel = (tournamentId: string, diamondId: string) =>
    tournamentId && diamondId ? `${tournamentId}_REPORT_DIAMOND_${diamondId}_JSON` : undefined;

const getDisciplineRecordsChannel = (tournamentId: string, recordsId: string) =>
    tournamentId && recordsId ? `${tournamentId}_COMPRECORDS_${recordsId}_JSON` : undefined;
